<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/courseList' }"
          >自有课程</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{this.$route.query.id?"编辑特色课程":"新建特色课程"}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">特色课程基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formExtra" label-width="120px">
              <el-form-item label="特色课程名称:">
                <el-input v-model="formExtra.name"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="特色课程图片:">
                <el-row type="flex" class="row-bg" style="width: 200px">
                  <el-col :span="12" v-if="formExtra.image != ''">
                    <img :src="formExtra.image" width="80px" height="80px" />
                  </el-col>
                  <el-col :span="12" v-else-if="this.backupImage != ''">
                    <img :src="this.backupImage" width="80px" height="80px" />
                  </el-col>

                  <el-col :span="12">
                    <Upload
                      action="/aries-api/resource/upload"
                      accept="image/jpeg, image/gif, image/png"
                      :before-upload="onBeforeUpload"
                      :on-success="onSuccessUploadPkgImage"
                      :data="uploadData"
                      :show-upload-list="false"
                    >
                      <el-button size="mini" type="primary">
                        上传
                        <i class="el-icon-upload el-icon--right"></i>
                      </el-button>
                    </Upload>
                  </el-col>
                  <el-col :span="3" v-if="formExtra.image != ''">
                      <el-button size="mini" type="danger" @click="delFrontCover">
                        删除
                        <i class="el-icon-delete"></i>
                      </el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <br />
              <el-form-item label="级别:">
                <el-select
                  v-model="formExtra.level"
                  clearable
                  style="width: 185px"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="关联资源:">
                <courseAddBook @choseResult="multyaddBooks" />
              </el-form-item>
              <br />
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formExtra.desc"
                  type="textarea"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <div>
        <el-button
          type="primary"
          style="margin-left: 45%; margin-top: 10px; margin-bottom: 50px"
          @click="nextStep"
          :loading="loadingBtn"
          >下一步</el-button
        >
        <el-button @click="cancelEdit">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { ApiMessage, formatDate } from "@/utils/util";
import courseAddBook from "../componentsEdu/courseAddBook";

export default {
  name: "extraAddNew",
  components: { courseAddBook },
  data() {
    return {
      formExtra: {
        name: "",
        level: "",
        image: "",
        desc: "",
      },
      levelList: [
        {
          value: "初级",
          label: "初级",
        },
        {
          value: "中级",
          label: "中级",
        },
        {
          value: "高级",
          label: "高级",
        },
        {
          value: "桥梁",
          label: "桥梁",
        },
        {
          value: "初章",
          label: "初章",
        },
        {
          value: "中章",
          label: "中章",
        },
        {
          value: "高章",
          label: "高章",
        },
      ],
      uploadData: {
        isOnlyMP3: "false",
        pdfToPng: "false",
      },
      currId: "",
      albumId: "",
      backupImage: "",
      extraEnabled: false,
      multipleSelection: [],
      loadingBtn: false,
    };
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
      };

      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res).list[0];
            this.formExtra.name = m.name;
            this.formExtra.level = m.level;
            this.backupImage = m.image;
            this.formExtra.desc = m.desc;
            this.extraEnabled = m.enabled;
            this.albumId = m.albumId;
          }
        }
      );
    }
  },
  watch: {},
  methods: {
    delFrontCover(){
      this.formExtra.image = ''
    },
    cancelEdit() {
      this.$router.push({
        name: "courseList",
      });
    },
    nextStep() {
      if (this.formExtra.name == "") {
        alert("课包名称为必填项");
        return;
      }
      this.loadingBtn = true;

      let params = {
        appId: this.$API.APPID,
        name: this.formExtra.name,
        level: this.formExtra.level,
        image: this.formExtra.image ? this.formExtra.image : this.backupImage,
        enabled: this.extraEnabled,
        desc: this.formExtra.desc,
        // type: "10"
      };
      if (this.currId != "") {
        params.id = `${this.currId}`;
      }
      
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_save", params).then(
        (res) => {
          if (res != null) {
            this.loadingBtn = false;

            let m = JSON.parse(res);
            this.currId = m.id;
            this.albumId = m.albumId;
            if (this.multipleSelection.length > 0) {
              this.handleResAdd2Server(this.multipleSelection).then((res) => {
                if (res != null) {
                  this.jumpToDetail();
                }
              });
            } else {
              this.jumpToDetail();
            }
          }
        }
      );
    },
    jumpToDetail() {
      this.$router.push({
        name: "myextra",
        query: {
          id: this.currId,
          albumId: this.albumId,
        },
      });
    },
    onBeforeUpload() {
      return true;
    },
    onSuccessUploadPkgImage(response, file, fileList) {
      console.log(response);
      this.formExtra.image = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    multyaddBooks(params) {
      if (params != null) {
        //this.handleResAdd2Server(params.sel);
        this.$Message.success("资源已添加到待确认列表");
        this.multipleSelection.push(params.sel);
      }
    },
    handleResAdd2Server(arr) {
      console.log(arr);
      // debugger
      return new Promise((resolve, reject) => {
        let res = [];
        arr.forEach(function (v, i) {
          v.forEach(function (v, i) {
            // debugger
            // console.log(v)
            // console.log(v.id)
            // console.log(v.dbId)
            let tmp = {
              id: v.id,
              dbId: v.dbId,
            };
            res.push(tmp);
          });
        });
        console.log(res, "90099090909090");
        // for (let i = 0; i < arr.length; ++i) {
        //   let tmp = {
        //     id: arr[i].id,
        //     dbId: arr[i].dbId,
        //   };
        //   res.push(tmp);
        // }
        // console.log(res,'899999')
        // debugger;
        let params = {
          appId: this.$API.APPID,
          id: Number(this.albumId),
          resList: res,
        };
        console.log(params);
        this.$axios
          .post("/aries-api/album/saveRes", params)
          .then((response) => {
            console.log(response);
            let m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.msg));
            } else {
              ApiMessage(this, m.err, "error");
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// extraAddNew.vue?26d92a08